import type { CreateClientFormData } from '@/types/clientsApiTypes';
import type { LoyaltyProgramActionItem, LoyaltyProgramsFormValues } from '../../sections/loyaltyProgramsSection/types';

/** Placeholder lp_id for empty row when modal has no saved items; must be treated as create, not update. */
const MOCK_LOYALTY_PROGRAM_LP_ID = 0;

function isRealLoyaltyProgramId(id: number | null | undefined): id is number {
  return id != null && id !== MOCK_LOYALTY_PROGRAM_LP_ID;
}

export function getLoyaltyProgramsPayload(
  values: LoyaltyProgramsFormValues,
  client: CreateClientFormData | null | undefined
): LoyaltyProgramActionItem[] {
  const initial = client?.primary_passenger?.loyalty_numbers ?? [];
  const current = values.primary_passenger?.loyalty_numbers ?? [];
  const initialIds = new Set(initial.map((row) => row.lp_id).filter(isRealLoyaltyProgramId));
  const currentIds = new Set(current.map((row) => row.lp_id).filter(isRealLoyaltyProgramId));

  const items: LoyaltyProgramActionItem[] = [];

  for (const row of initial) {
    if (!isRealLoyaltyProgramId(row.lp_id)) continue;
    if (!currentIds.has(row.lp_id)) {
      items.push({
        id: row.lp_id,
        category: row.category_id ?? undefined,
        is_legacy: row.is_legacy,
        number: row.number ?? '',
        loyalty_program: row.loyalty_program ?? null,
        frequent_flyer_number: row.frequent_flyer_number ?? null,
        note: row.note ?? null,
        action: 'delete',
      });
    }
  }

  for (const row of current) {
    const categoryId = row.category_id ?? null;
    const num = row.number ?? '';
    const loyaltyProgram = row.loyalty_program ?? null;
    const frequentFlyerNumber = row.frequent_flyer_number ?? null;
    const note = row.note ?? null;

    if (isRealLoyaltyProgramId(row.lp_id) && initialIds.has(row.lp_id)) {
      items.push({
        id: row.lp_id,
        category: categoryId ?? undefined,
        is_legacy: row.is_legacy,
        number: num,
        loyalty_program: loyaltyProgram,
        frequent_flyer_number: frequentFlyerNumber,
        note,
        action: 'update',
      });
    } else {
      // lp_id is null, undefined, or mock id 0 → create
      items.push({
        category_id: categoryId ?? undefined,
        is_legacy: row.is_legacy,
        number: num,
        loyalty_program: loyaltyProgram,
        frequent_flyer_number: frequentFlyerNumber,
        note,
        action: 'create',
      });
    }
  }

  return items;
}